module.exports = __webpack_public_path__ + "static/media/icons8-shirt.76666e97.svg";